/**
 * Server-side rendered View
 * Binding the Backbone View to all server-side rendered elements
 * matching the el selector.
 *
 * @author Daniel Kvistgaard <dkvistgaard@vertic.com>
 */

import _ from 'underscore';
import BackboneView from './view';

const getNewView = function newView(view, extendView) {
	const viewClone = _.clone(view);

	// Creating a new view with the same functionality as this view
	const NewView = extendView.extend();
	_.extend(NewView.prototype, _.omit(viewClone, 'el'));

	return NewView;
};

const ServerView = BackboneView.extend({
	constructor: function constructor(options) {
		// If the selector is a string and not an id selector
		if (typeof this.el === 'string' && this.el.substr(0, 1) !== '#') {
			const elems = document.querySelectorAll(this.el);
			const hasViewClass = `has-view--${this.el.replace(/\s/g, '-').replace(/[.,]/g, '')}`;

			// Stop if no elements are found
			if (!elems || elems.length === 0) {
				return;
			}

			// Loop through all found elements to initialise a new view per element
			[].forEach.call(elems, (elem) => {
				if (elem.classList.contains(hasViewClass)) {
					return;
				}

				// Creating a new view with the same functionality as this view
				const ElView = getNewView(this, ServerView);
				ElView.prototype.el = elem;

				elem.classList.add(hasViewClass);

				// Initialize the new view
				new ElView(options); // eslint-disable-line no-new
			});
		} else {
			if (typeof this.onBeforeRender === 'function') this.onBeforeRender.call(this);

			// Initialize a normal Backbone View
			BackboneView.apply(this, [options]);

			if (typeof this.onRender === 'function') this.onRender.call(this);
		}
	},
});

export default ServerView;
